import React from "react";
import { SideIllustration } from "../components/common/SideIllustration";
import { IMAGE_SOURCES } from "../mock/imageSources";

export default function TeacherResources() {
  return (
    <div className="space-y-8">
      <section className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Teacher Resources &amp; Support</h1>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          Authorized teachers have access to a range of resources designed to support examination preparation and broader musical learning. Materials are updated periodically to reflect syllabus developments and evolving best practice in music education at Global Music Conservatory.
        </p>
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Resources</h2>
          <ul className="space-y-1">
            <li>• Syllabi outlining repertoire lists, technical requirements and examination formats.</li>
            <li>• Sample examination materials and indicative question formats where applicable.</li>
            <li>• Guidance on interpreting assessment criteria and mark schemes.</li>
          </ul>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.resourcesSheetViolin}
          alt="Sheet music and violin in a formal practice setting"
        />
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-slate-50/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Support</h2>
          <ul className="space-y-1">
            <li>• Periodic information bulletins regarding upcoming examination sessions.</li>
            <li>• Clarifications on syllabus content and administrative procedures.</li>
            <li>• Channels for feedback to the board on examination materials and processes.</li>
          </ul>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.resourcesNotes}
          alt="Close-up of musical notation used in examination preparation"
        />
      </section>
    </div>
  );
}
